<template class="full-height">
  <div class="member-app-container" style="position: relative; height: 100%">
    <member-data :pageRoles="roles" :title="title" />
  </div>
</template>
<script>
export default {
  name: 'tcMemberManagement',
  components: {
    memberData: () => import('@/views/ita/toursCombine/member/components/memberIntroList.vue'),
  },
  data() {
    return {
      roles: ['TC-MANUFACTURER'],
      title: 'MANUFACTURER',
    }
  },
}
</script>
<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>
